import { Radio, Select } from 'antd';
import { Form, Formik } from 'formik';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { InfoIcon } from 'src/icons';
import { settingsOrgFlag } from 'src/store/actions/appointment.action';
import { Button } from '../baseComponents';
import { createOrganizationTime } from 'src/store/actions/settings.action';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

const Organization = ({ activeButton }) => {
  const dispatch = useDispatch();
  const { settingsOrgValue } = useSelector((state) => state?.appointmentState);
  const [store_BE_Start_hour, setStore_BE_Start_hour] = useState('');
  const [store_BE_End_hour, setStore_BE_End_hour] = useState('');
  const [notificationStartRadio, setNotificationStartRadio] = useState(null);
  const [notificationEndRadio, setNotificationsEndRadio] = useState(null);
  const [notificationStartHour, setNotificationStartHour] = useState('');
  const [notificationEndHour, setNotificationEndHour] = useState('');
  const [notificationStartMinute, setNotificationStartMinute] = useState('');
  const [notificationEndMinute, setNotificationEndMinute] = useState('');
  const isMobile = window.innerWidth < 1260;
  const { user } = useAuth();

  const notification_startTime_options = [
    { title: '7', value: '7' },
    { title: '8', value: '8' },
    { title: '9', value: '9' },
    { title: '10', value: '10' },
    { title: '11', value: '11' },
    { title: '12', value: '12' },
    { title: '1', value: '1' },
    { title: '2', value: '2' },
    { title: '3', value: '3' },
    { title: '4', value: '4' },
    { title: '5', value: '5' },
    { title: '6', value: '6' },
  ];

  const notification_startTime_minute_options = [
    { title: '00', value: '00' },
    { title: '05', value: '05' },
    { title: '10', value: '10' },
    { title: '15', value: '15' },
    { title: '20', value: '20' },
    { title: '25', value: '25' },
    { title: '30', value: '30' },
    { title: '35', value: '35' },
    { title: '40', value: '40' },
    { title: '45', value: '45' },
    { title: '50', value: '50' },
    { title: '55', value: '55' },
  ];

  const notification_endTime_minute_options = [
    { title: '00', value: '00' },
    { title: '05', value: '05' },
    { title: '10', value: '10' },
    { title: '15', value: '15' },
    { title: '20', value: '20' },
    { title: '25', value: '25' },
    { title: '30', value: '30' },
    { title: '35', value: '35' },
    { title: '40', value: '40' },
    { title: '45', value: '45' },
    { title: '50', value: '50' },
    { title: '55', value: '55' },
  ];

  const notification_endTime_options = [
    { title: '7', value: '7' },
    { title: '8', value: '8' },
    { title: '9', value: '9' },
    { title: '10', value: '10' },
    { title: '11', value: '11' },
    { title: '12', value: '12' },
    { title: '1', value: '1' },
    { title: '2', value: '2' },
    { title: '3', value: '3' },
    { title: '4', value: '4' },
    { title: '5', value: '5' },
    { title: '6', value: '6' },
  ];

  const startTimeAmpmOptions = [
    { label: 'AM', value: 1 },
    { label: 'PM', value: 2 },
  ];
  const endTimeAmpmOptions = [
    { label: 'AM', value: 1 },
    { label: 'PM', value: 2 },
  ];

  useEffect(() => {
    dispatch(settingsOrgFlag());
  }, [dispatch]);

  useEffect(() => {
    setStore_BE_Start_hour(
      settingsOrgValue?.organization_start_time
        ? settingsOrgValue?.organization_start_time
        : ''
    );
    setStore_BE_End_hour(
      settingsOrgValue?.organization_end_time
        ? settingsOrgValue?.organization_end_time
        : ''
    );

    let default_start_hour, default_end_hour;

    // Split the final start hour and end hour strings
    const [split_start_hour, split_start_minute] =
      // eslint-disable-next-line no-unsafe-optional-chaining
      store_BE_Start_hour?.split(':');
    // eslint-disable-next-line no-unsafe-optional-chaining
    const [split_end_hour, split_end_minute] = store_BE_End_hour?.split(':');

    // Convert backend UTC time to local time using today's date for correct DST offset
    const today = dayjs().format('YYYY-MM-DD');
    const startLocal = dayjs(
      `${today}T${split_start_hour}:${split_start_minute}:00Z`
    );
    const endLocal = dayjs(
      `${today}T${split_end_hour}:${split_end_minute}:00Z`
    );

    // Get local hours
    const local_start_hours = startLocal.hour();
    const local_end_hours = endLocal.hour();

    // Set notification start hour and end hour
    default_start_hour = local_start_hours;
    default_end_hour = local_end_hours;

    if (default_start_hour) {
      const parsedHour = parseInt(default_start_hour);
      if (!isNaN(parsedHour) && parsedHour >= 0 && parsedHour <= 11) {
        setNotificationStartRadio(1);
      } else {
        setNotificationStartRadio(2);
      }
    }

    if (default_end_hour) {
      const parsedHour = parseInt(default_end_hour);
      if (!isNaN(parsedHour) && parsedHour >= 0 && parsedHour <= 11) {
        setNotificationsEndRadio(1);
      } else {
        setNotificationsEndRadio(2);
      }
    }

    // Handle 12-hour format and set notification start hour
    if (local_start_hours === 0) {
      default_start_hour = 12; // Midnight is represented as 12 AM
    } else if (local_start_hours > 12) {
      default_start_hour = local_start_hours - 12;
    }

    // Handle 12-hour format and set notification end hour
    if (local_end_hours === 0) {
      default_end_hour = 12; // Midnight is represented as 12 AM
    } else if (local_end_hours > 12) {
      default_end_hour = local_end_hours - 12;
    }

    // Set notification start minute, hour, and radio
    setNotificationStartMinute(
      startLocal.minute() < 10 ? '0' + startLocal.minute() : startLocal.minute()
    );
    setNotificationStartHour(default_start_hour);

    // Set notification end minute, hour, and radio
    setNotificationEndMinute(
      endLocal.minute() < 10 ? '0' + endLocal.minute() : endLocal.minute()
    );
    setNotificationEndHour(default_end_hour);
  }, [settingsOrgValue, store_BE_End_hour, store_BE_Start_hour]);

  const formatting_Time = (hour, meredien) => {
    const am_pm_Radio =
      meredien === 'start' ? notificationStartRadio : notificationEndRadio;
    if (am_pm_Radio === 2 && hour !== 12) {
      hour += 12;
    }
    if (am_pm_Radio === 1 && hour === 12) {
      hour = 0;
    }
    return hour;
  };

  useEffect(() => {
    if (notificationStartHour === 12 && notificationStartRadio === null) {
      setNotificationStartRadio(1);
    }

    if (notificationEndHour === 12 && notificationEndRadio === null) {
      setNotificationsEndRadio(1);
    }
  }, [
    notificationStartHour,
    notificationEndHour,
    notificationStartRadio,
    notificationEndRadio,
  ]);

  const handleSubmit = () => {
    const startHour = parseInt(notificationStartHour);
    const startMinute = parseInt(notificationStartMinute);
    let formatted_start_hour = startHour;
    const start_time = formatting_Time(formatted_start_hour, 'start');

    // Convert local time to UTC
    const startDate = dayjs()
      .hour(start_time)
      .minute(startMinute)
      .second(0)
      .toDate();
    const final_Start_Time = `${String(startDate.getUTCHours()).padStart(2, '0')}:${String(startDate.getUTCMinutes()).padStart(2, '0')}`;

    const endHour = parseInt(notificationEndHour);
    const endMinute = parseInt(notificationEndMinute);
    let formatted_end_hour = endHour;
    const end_time = formatting_Time(formatted_end_hour, 'end');
    const endDate = dayjs().hour(end_time).minute(endMinute).second(0).toDate();
    const final_End_Time = `${String(endDate.getUTCHours()).padStart(2, '0')}:${String(endDate.getUTCMinutes()).padStart(2, '0')}`;

    const organization_payload = {
      notification_start_time: final_Start_Time,
      notification_end_time: final_End_Time,
    };
    analytics.track('Clicked Save In Patient Notifications Window', {
      email: user?.email,
    });
    dispatch(createOrganizationTime(organization_payload));
  };

  return (
    <>
      <Formik enableReinitialize initialValues={{}} onSubmit={handleSubmit}>
        {({ handleSubmit }) => (
          <>
            <Form onSubmit={handleSubmit} initialValues={{}} autoComplete="off">
              {activeButton === 'Notifications' && (
                <>
                  <div
                    className={`${isMobile ? 'mb-24' : ''} bg-white px-4 py-2 rounded-2xl mt-4`}
                  >
                    <div className="mt-2 ml-1 text-lg font-semibold text-[#000]">
                      Patient notifications window
                    </div>
                    <div className="inline-block ">
                      <div className="flex items-center bg-[#e6f4ff] rounded-lg border border-[#91caff] pr-2 mt-1">
                        <div className="mt-2 ml-2">
                          <InfoIcon />
                        </div>
                        <div className="text-[#000] mt-0.5">
                          Patients receive scheduled notifications only in this
                          duration
                        </div>
                      </div>
                    </div>

                    <div
                      className={`${isMobile ? 'gap-4' : 'gap-8'} flex mt-5`}
                    >
                      <div className="flex items-center text-[#000] font-medium">
                        Notification Start time
                      </div>
                      <div className={isMobile ? 'w-2/6' : 'w-1/6'}>
                        <Select
                          className=" bg-white  p-1 outline-1 outline-[#E5E8EB] outline-none font-sans h-12 flex items-center focus:outline-none rounded-xl"
                          placeholder="Hour"
                          bordered={false}
                          value={
                            notificationStartHour
                              ? notificationStartHour.toString()
                              : null
                          }
                          showSearch
                          options={notification_startTime_options}
                          onChange={(e) => {
                            setNotificationStartHour(e);
                          }}
                        />
                      </div>
                      <div className={isMobile ? 'w-2/6' : 'w-1/6'}>
                        <Select
                          className=" bg-white  p-1 outline-1 outline-[#E5E8EB] outline-none font-sans h-12 flex items-center focus:outline-none rounded-xl"
                          placeholder="Min"
                          bordered={false}
                          value={
                            notificationStartMinute
                              ? notificationStartMinute
                              : null
                          }
                          showSearch
                          options={notification_startTime_minute_options}
                          onChange={(e) => {
                            setNotificationStartMinute(e);
                          }}
                        />
                      </div>
                      <div className="flex items-center">
                        <Radio.Group
                          options={startTimeAmpmOptions}
                          onChange={(e) => {
                            setNotificationStartRadio(e.target.value);
                          }}
                          value={notificationStartRadio}
                          defaultValue={null}
                        ></Radio.Group>
                      </div>
                    </div>
                    <div
                      className={`${isMobile ? 'gap-4' : 'gap-8'} mt-5 flex`}
                    >
                      <div className="flex items-center text-[#000] font-medium">
                        Notification End time
                      </div>
                      <div className={isMobile ? 'w-2/6' : 'w-1/6 ml-1.5'}>
                        <Select
                          className=" bg-white  p-1 outline-1 outline-[#E5E8EB] outline-none font-sans h-12 flex items-center focus:outline-none rounded-xl"
                          bordered={false}
                          showSearch
                          placeholder="Hour"
                          value={
                            notificationEndHour
                              ? notificationEndHour.toString()
                              : null
                          }
                          options={notification_endTime_options}
                          onChange={(e) => {
                            setNotificationEndHour(e);
                          }}
                        />
                      </div>
                      <div className={isMobile ? 'w-2/6' : 'w-1/6'}>
                        <Select
                          className=" bg-white  p-1 outline-1 outline-[#E5E8EB] outline-none font-sans h-12 flex items-center focus:outline-none rounded-xl"
                          placeholder="Min"
                          bordered={false}
                          value={
                            notificationEndMinute ? notificationEndMinute : null
                          }
                          showSearch
                          options={notification_endTime_minute_options}
                          onChange={(e) => {
                            setNotificationEndMinute(e);
                          }}
                        />
                      </div>
                      <div className="flex items-center">
                        <Radio.Group
                          options={endTimeAmpmOptions}
                          onChange={(e) => {
                            setNotificationsEndRadio(e.target.value);
                          }}
                          value={notificationEndRadio}
                          defaultValue={null}
                        ></Radio.Group>
                      </div>
                    </div>
                    <div className="mt-5 border-b-2 border-[#E5E8EB]"></div>
                    <div className="flex mt-5 justify-end">
                      <Button
                        className={`flex mx-1 bg-[#00d091]  hover:bg-[#059669] hover:ring-[#059669] rounded-xl cursor-pointer  text-[#fff] text-base px-6 py-2`}
                        onClick={handleSubmit}
                        type={'cancel'}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default Organization;
